<template>
  <v-container fluid fill-height pa-0>
    <v-layout column fill-height ma-0 pa-1>
      <v-layout fill-height ma-0 pa-0 >
        <v-flex xs12 >
          <scroll-area>
            <template slot="header">
              <v-layout fill-height ma-0 pa-0>
                <v-flex xs6 class="pr-1">
                  <v-select :data-testid="$options.name + 'v-select' + 'model.obj'"
                    v-model="model.obj"
                    light
                    auto-grow
                    :items="getItems"
                    :item-text="'id'"
                    :item-value="'id'"
                    :label="$t('VLan ID')"
                    outline
                    hide-details
                    return-object
                    class="white"
                    background-color="primary"
                    rows="1"
                    height="56.48"
                  >
                  </v-select>
                </v-flex>

                <v-flex xs6 >
                  <v-text-field
                    v-if="model.obj"
                    v-model="model.obj.name"
                    light
                    auto-grow
                    outline
                    readonly
                    flat
                    :label="$t('VLan name')"
                    hint
                    class="white"
                    background-color="primary"
                    hide-details
                    rows="1"
                  ></v-text-field>
                  
                </v-flex>
              </v-layout>
            </template>

            <template slot="body">

              <v-layout v-for="(item, i) in getVlanStructure" :key="'vlan_' + i" pt-1>
                <v-flex xs3 class="pr-1">
                  <v-text-field
                    v-model="item.name"
                    light
                    auto-grow
                    outline
                    readonly
                    flat
                    :label="$t('name')"
                    hint
                    class="white"
                    background-color="primary"
                    hide-details
                    rows="1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 >
                  <v-select :data-testid="$options.name + 'v-select' + 'item.value'"
                    v-model="item.value"
                    light
                    auto-grow
                    :items="['T', 'U']"
                    :label="$t('value')"
                    outline
                    hide-details
                    return-object
                    clearable
                    class="white"
                    background-color="primary"
                    rows="1"
                    height="56.48"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </template>
          </scroll-area>
        </v-flex>

        <v-flex v-show="groupUse" xs6 >
          <scroll-area>
            <template slot="body">
              <v-treeview
                :active.sync="treeActive"
                :open.sync="treeOpen"
                :items="$store.state.structure.manage.tree"
                active-class="grey lighten-4 indigo--text"
                selected-color="indigo"
                open-on-click
                selectable
                expand-icon="mdi-chevron-down"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                indeterminate-icon="indeterminate_check_box"
              >
                <template v-slot:label="{ item, open }">
                  <span class="caption font-weight-medium font-condensend">{{
                    item.name
                  }}</span>
                </template>
              </v-treeview>
            </template>
          </scroll-area>
        </v-flex>
      </v-layout>

      <v-flex shrink >
        <v-layout ma-0 pa-0>
          <v-layout ma-0 pa-0 justify-start>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'add'" small  color="primary" slot="activator" light text @click="">{{$t('add')}}</v-btn>
              <span>{{ $t('add') }}</span>
            </v-tooltip>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'add'" small  color="primary" slot="activator" light text @click="">{{$t('edit')}}</v-btn>
              <span>{{ $t('edit') }}</span>
            </v-tooltip>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'add'" small  color="primary" slot="activator" light text @click="">{{$t('remove')}}</v-btn>
              <span>{{ $t('remove') }}</span>
            </v-tooltip>
          </v-layout>
          <v-layout ma-0 pa-0 justify-end>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'groupUse--false'" v-if="groupUse" small color="primary" slot="activator" light text @click="groupUse = false">{{$t('individual use')}}</v-btn>
              <span>{{ $t('individual use') }}</span>
            </v-tooltip>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'groupUse--true'" v-if="!groupUse" small color="primary" slot="activator" light text @click="groupUse = true">{{$t('group use')}}</v-btn>
              <span>{{ $t('group use') }}</span>
            </v-tooltip>
            <v-tooltip dark color="secondary" bottom>
              <v-btn :data-testid="$options.name + 'v-btn' + 'add'" small  color="primary" slot="activator" light text @click="">{{$t('save changes')}}</v-btn>
              <span>{{ $t('save changes') }}</span>
            </v-tooltip>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import VlanStructure from '@/nms/components/device-configuration/manage/page/switching/vlan/vlan-structure.js'

// Типы
interface VlanItem {
  id: number
  name: string
}

interface ModelData {
  obj: any | null
}

interface VlanPortMembershipData {
  [key: string]: any
}

export default Vue.extend({
  name: 'VLAN_PORT_MEMBERSHIP',

  components: {
    scrollArea,
  },

  props: {
    data: {
      type: Object as () => VlanPortMembershipData,
      default: () => ({})
    },
  },

  data(): {
    groupUse: boolean
    treeActive: any[]
    treeOpen: any[]
    model: ModelData
  } {
    return {
      groupUse: false,
      treeActive: [],
      treeOpen: [],
      model: {
        obj: null
      }
    }
  },

  computed: {
    getData(): VlanPortMembershipData {
      return this.data
    },

    getVlanStructure(): any {
      return VlanStructure
    },

    getItems(): VlanItem[] {
      return [
        {
          id: 1,
          name: 'VLan name 1',
        },
        {
          id: 2,
          name: 'VLan name 2'
        },
        {
          id: 3,
          name: 'VLan name 3'
        },
        {
          id: 4,
          name: 'VLan name 4'
        },
      ]
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },
  },
})
</script>

<style lang="css" scoped>
</style>
